/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_Inventory_Min_LevelInputs */

const vi_report_inventory_min_level = /** @type {(inputs: Report_Inventory_Min_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mức tối thiểu`)
};

/**

* @param {Report_Inventory_Min_LevelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const report_inventory_min_level = /** @type {((inputs?: Report_Inventory_Min_LevelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Inventory_Min_LevelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_report_inventory_min_level(inputs)
});